export const cloneDeepObject = obj => {
  return JSON.parse(JSON.stringify(obj));
};
export const escapeHtml = str => {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export function handleHtmlData(htmlData) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${htmlData}</div>`, 'text/html');
  const container = doc.body.firstElementChild;

  const result = [];
  const generateId = () =>
    `section-freestyle-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
  let tempGroup = [];

  const flushTempGroup = () => {
    const content = tempGroup
      .map(node => node.outerHTML)
      .join('')
      .trim();
    if (!content) return;

    const id = generateId();
    const html = `<section class="ck-content" data-section="${id}" data-type="section-freestyle" data-title="Freestyle">
        <div data-attribute="content">${content}</div>
      </section>`;

    result.push({
      id,
      type: 'section-freestyle',
      title: 'Freestyle',
      html,
    });

    tempGroup = [];
  };

  for (const node of Array.from(container.childNodes)) {
    if (node.nodeType !== 1 && node.nodeType !== 3) continue; //just handle element and text node
    // node.innerHTML = node.innerHTML.replace(
    //   /<link rel="stylesheet" href="https:\/\/cdn\.jsdelivr\.net\/npm\/swiper@11\/swiper-bundle\.min\.css" \/>/g,
    //   '',
    // );
    if (node.tagName === 'LINK' && node.getAttribute('data-attribute') === 'cdn-swiper') continue;

    const html = node.outerHTML?.trim() || node.textContent.trim();
    if (!html) continue;

    if (node.nodeType === 1 && node.tagName === 'SECTION') {
      const el = node;
      let id = el.getAttribute('data-section');
      const type = el.getAttribute('data-type');
      let title = el.getAttribute('data-title');

      if (id && type) {
        flushTempGroup();

        if (!title) {
          title = '';
          el.setAttribute('data-title', title);
        }

        result.push({
          id,
          type,
          title,
          html: el.outerHTML,
        });
      } else {
        tempGroup.push(el);
      }
    } else {
      tempGroup.push(node);
    }
  }

  flushTempGroup();

  return result;
}

export const handleSectionTemplate = {
  insertNewId(template) {
    const isDev = process.env.NODE_ENV === 'development';
    if (!template || !template.html || !template.type) return {};
    const { image, html: htmlString, title, type: sectionType } = template;
    const newId = `${sectionType}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    const prefix = 'prl-';
    const uniqueId = Math.random()
      .toString(36)
      .slice(2, 8);
    const regex = new RegExp(`prl-[a-z0-9]{6}`, 'g');

    const replacedHtmlString = htmlString.replace(regex, prefix + uniqueId).replace(/unique-id/g, prefix + uniqueId);
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${replacedHtmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const el = container.querySelector('[data-section]');
    if (el) {
      el.setAttribute('data-section', newId);
      el.setAttribute('data-type', sectionType);
    }
    if (!isDev) {
      const CDN_PREFIX = 'https://cdn.skyfastimg.com/';
      const LOCAL_PREFIX = '/uploads/';
      const QUERY = '?w=1920&h=auto';

      container.querySelectorAll('img[src]').forEach(img => {
        const src = img.getAttribute('src');
        if (src && src.startsWith(CDN_PREFIX)) {
          const path = src.slice(CDN_PREFIX.length).split(/[?#]/)[0];
          img.setAttribute('src', LOCAL_PREFIX + path + QUERY);
        }
      });
    }
    return {
      id: newId,
      title,
      type: sectionType,
      html: container.innerHTML.trim(),
      image,
    };
  },
};

export const optimizeRawHtmlData = {
  injectCDNIfNeeded(htmlData) {
    if (!htmlData || htmlData.trim() === '') return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlData}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const cdnSwiper = () => {
      const existingLinks = Array.from(container.querySelectorAll('[data-attribute="cdn-swiper"]'));
      existingLinks.forEach(linkEl => linkEl.remove());

      const hasSwiper = container.querySelector('.swiper');
      if (hasSwiper) {
        const linkEl = doc.createElement('link');
        linkEl.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css');
        linkEl.setAttribute('rel', 'stylesheet');
        linkEl.setAttribute('type', 'text/css');
        linkEl.setAttribute('data-attribute', 'cdn-swiper');
        container.insertBefore(linkEl, container.firstChild);
      }
    };

    cdnSwiper();
    return container.innerHTML.trim();
  },
  watchSectionStyles(sections, oldSections) {
    const parseContainer = html =>
      new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html').body.firstElementChild;

    const styleSectionsForEach = {};
    const allSources = [...sections, ...(oldSections ?? [])];

    for (const { html, type } of allSources) {
      if (styleSectionsForEach[type]) continue;

      const styleEl = parseContainer(html).querySelector('style');
      if (styleEl) {
        styleSectionsForEach[type] = styleEl.innerHTML;
      }
    }

    const seenTypes = new Set();

    return sections.map(section => {
      const { type } = section;
      const container = parseContainer(section.html);

      container.querySelectorAll('style').forEach(s => s.remove());

      if (!seenTypes.has(type)) {
        seenTypes.add(type);

        const styleHTML = styleSectionsForEach[type];
        if (styleHTML) {
          container.firstElementChild?.firstChild?.before(
            Object.assign(document.createElement('style'), { innerHTML: styleHTML }),
          );
        }
      }

      return { ...section, html: container.innerHTML.trim() };
    });
  },
};

const parseSection = rawHtml => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${rawHtml || ''}</div>`, 'text/html');
  const container = doc.body.firstElementChild;
  const sectionEl = container?.querySelector?.('section');
  return { doc, container, sectionEl };
};

const generateSectionId = () =>
  `section-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 8)}`;

export const regenerateSectionIds = sections => {
  const list = Array.isArray(sections) ? sections : [];

  return list.map(section => {
    if (!section) return section;
    return handleSectionTemplate.insertNewId(section);
  });
};
